import { apiSlice } from './apiSlice';

export interface DeleteUserResponse {
  success: boolean;
  message: string;
}

export const deleteUserApi = apiSlice.injectEndpoints({
  endpoints: (builder) => ({
    deleteUser: builder.mutation<DeleteUserResponse, string>({
      query: (userId) => ({
        url: `/users/delete-user?userId=${userId}`,
        method: 'DELETE',
      }),
      invalidatesTags: ['User'],
    }),
  }),
});

export const { useDeleteUserMutation } = deleteUserApi;
